import { createAction } from 'redux-actions';

export const ADD_TO_LOADING = 'ADD_TO_LOADING';
export const addToLoading = createAction(ADD_TO_LOADING);

export const RM_FROM_LOADING = 'RM_FROM_LOADING';
export const rmFromLoading = createAction(RM_FROM_LOADING);
